import { CustomerInterface } from "./customer.interface";
import { InvoiceInterface } from "./invoice.interface";

export enum TaskStatus {
    InProgress = "in-progress",
    Completed = "completed",
    Queued = "queued",
    ToBePickedUp = "to-be-picked-up"
}

interface Task {
    id: number;
    date: Date;
    type: string;
    status: TaskStatus;
    customer: CustomerInterface | null;
    subject: string;
    chatGptLink?: string;
    description: string;
    dueDate: string;
    quote: number;
    log: TaskLog[];
    invoice?: InvoiceInterface;
    snooze?: {
        until: Date,
        comment: string;
    }
    today?: Date;
    waitingForParts?: boolean;
}

interface TaskLog {
    date: Date;
    text: string;
    type: string;
}
  
interface RepairComments {

}

export { Task }
